export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14236.52fb4a83.jpg";